import React, { Component } from 'react';
import { Header } from "./components/Header.js";
import './App.css';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Form from './components/Form.js';
import Survey from './components/Survey.js';
import Donut from './components/Donut.js';
import { reformattedQuiz, parseResult } from "./components/quizQuestions.js";
import Results from './components/Results.js'
import axios from "axios";

const host_ip = window.location.hostname;

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      details: {},
      detailsFilled: false,
      resultsFilled: false,
      submitted: false
    }
    this.onResults = this.onResults.bind(this);
    this.onDetails = this.onDetails.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  

  onResults = async values => {
    this.setState({ results: parseResult(values, reformattedQuiz) });
    this.setState({ resultsFilled: true })
  }

  onDetails = async values => {
    this.setState({details: values});
    this.setState({ detailsFilled: true })
  }
  onSubmit() {
    axios.post("https://firesurvey.herokuapp.com/email",{
      details: this.state.details,
      results: this.state.results
    }).then(res => {console.log(res);
    this.setState({submitted: true})})
  }
  render() {
    return (
      <div className="App">
        <Header />
        <Container>
          <Box my={2} style={{ margin: "5%", "font-family": "Roboto" }}>
            <p style={{ "font-size": "200%", "text-shadow": "1px 1px grey  " }}>Welcome to Firevisor's Industry 4.0 Readiness Tool</p>
            {this.state.detailsFilled ? "" : <Form function={this.onDetails} />}
            {this.state.detailsFilled && !this.state.resultsFilled? <Survey function={this.onResults} />: ""}
            {this.state.resultsFilled && this.state.detailsFilled? <div>
              <Donut data={this.state.results}/>
              <Results function={this.onSubmit} data={this.state.results}/>
              </div> : ""}
              <div style={{"padding-top": "10%", "font-size": "200%"}}> {this.state.submitted? "Results submitted!\n Thank you!": ""} </div>
          </Box>
        </Container>
      </div>
    );
  }
}